<template>
  <div class="fullscreen-loading" :class="{ 'is-active': isActive }" :style="{ backgroundColor: backgroundColor }">
    <div class="loading-spinner">
      <!-- 加载动画 -->
      <div class="spinner"></div>
      <!-- 加载文本 -->
      <p class="loading-text" v-if="text">{{ text }}</p>
    </div>
  </div>
</template>

<script setup>
  import {
    defineProps
  } from 'vue';

  // 定义组件属性
  const props = defineProps({
    // 是否显示loading
    isActive: {
      type: Boolean,
      default: false
    },
    // 加载文本
    text: {
      type: String,
      default: '加载中...'
    },
    // 背景颜色
    backgroundColor: {
      type: String,
      default: 'rgba(255, 255, 255, 0.8)'
    }
  });
</script>

<style scoped>
  .fullscreen-loading {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.3s, visibility 0.3s;
  }

  .fullscreen-loading.is-active {
    opacity: 1;
    visibility: visible;
  }

  .loading-spinner {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  /* 加载动画样式 */
  .spinner {
    width: 40px;
    height: 40px;
    border: 4px solid #f3f3f3;
    border-top: 4px solid #3498db;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }

  /* 加载文本样式 */
  .loading-text {
    margin-top: 16px;
    color: #333;
    font-size: 16px;
  }

  /* 旋转动画 */
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }
</style>
